export default "__VITE_ASSET__26ac8785__"